import { createSelector } from 'reselect'

export const getSmsCodeStatus = createSelector(
  state => Boolean(state && state.user && state.user.registration && state.user.registration.smsCodeWasSent),
  wasSent => wasSent
)
